<template>
  <div class="page-background" :style="backgroundStyles"></div>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  imageUrl: {
    type: String,
    default: ''
  },
  position: {
    type: String,
    default: 'center'
  }
})

const backgroundStyles = computed(() => ({
  backgroundImage: props.imageUrl ? `url(${props.imageUrl})` : 'none',
  backgroundPosition: props.position
}))
</script>

<style scoped>
.page-background {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
  background-size: cover;
  background-repeat: no-repeat;
  background-color: #1e3a8a; /* Fallback color */
}
</style>
